import { DropZone } from "@measured/puck";
import { withContexts } from "./wrappers/withContexts";

export type RootProps = {
    className?: string;
};

function RootComponent() {
    return <DropZone zone="default-zone" style={{ minHeight: "100vh" }} />;
}

const Root = withContexts(RootComponent);
export default Root;
